module.exports = __webpack_public_path__ + "images/appStoresIcon-f82379bf69d94681e58bd32dfdd350ae.svg";